import { AfterViewInit, Component, ElementRef, Input, OnDestroy, ViewChild, inject } from '@angular/core';
import { BathroomConfigurationState } from 'src/app/models/configurators-2d/mobile/bathroom/bathroom-validation.models';
import { BathroomConfigurationService } from 'src/app/services/configurators-2d/mobile/bathroom/bathroom-configuration.service';
import { captureBathroomPreviewElement } from 'src/app/services/configurators-2d/mobile/bathroom/bathroom-preview-capture.util';

@Component({
  selector: 'ng-casto-bathroom-tunnel-conception-summary',
  templateUrl: './bathroom-tunnel-conception-summary.component.html',
  styleUrls: ['./bathroom-tunnel-conception-summary.component.scss'],
})
export class BathroomTunnelConceptionSummaryComponent implements AfterViewInit, OnDestroy {
  private readonly configurationService = inject(BathroomConfigurationService);
  private unregisterFallbackPreviewCapture: (() => void) | null = null;

  @ViewChild('summaryPreview') private summaryPreview!: ElementRef<HTMLDivElement>;

  @Input() configuration: BathroomConfigurationState | null = null;
  @Input() rangeName: string = '-';
  @Input() compositionName: string = '-';
  @Input() imageSrc: string = 'assets/img/bathroom/kentia_1.png';
  @Input() productsCount: number = 0;
  @Input() error: string | null = null;

  ngAfterViewInit(): void {
    this.unregisterFallbackPreviewCapture = this.configurationService.registerFallbackPreviewCapture(() =>
      this.captureSummaryPreview()
    );
  }

  ngOnDestroy(): void {
    this.unregisterFallbackPreviewCapture?.();
  }

  protected formatPrice(price?: number): string {
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR',
    }).format(price ?? 0);
  }

  private async captureSummaryPreview(): Promise<string | null> {
    if (!this.summaryPreview?.nativeElement || !this.configuration?.composition) return null;

    return await captureBathroomPreviewElement(
      this.summaryPreview.nativeElement,
      'Erreur lors de la capture de la preview du récapitulatif salle de bain'
    );
  }
}
